import { ReactComponent as MenuCompany } from "./company.svg";
import { ReactComponent as MenuCompanyActive } from "./company-active.svg";
import { ReactComponent as MenuEmployee } from "./employee.svg";
import { ReactComponent as MenuEmployeeActive } from "./employee-active.svg";
import { ReactComponent as MenuEngagement } from "./engage.svg";
import { ReactComponent as MenuEngagementActive } from "./engage-active.svg";
import { ReactComponent as MenuLeads } from "./leads.svg";
import { ReactComponent as MenuLeadsActive } from "./leads-active.svg";
import { ReactComponent as MenuLocation } from "./location.svg";
import { ReactComponent as MenuLocationActive } from "./location-active.svg";
import { ReactComponent as MenuProfileReview } from "./profile-review.svg";
import { ReactComponent as MenuProfileReviewActive } from "./profile-review-active.svg";
import { ReactComponent as MenuPreAssessment } from "./pre-assessment.svg";
import { ReactComponent as MenuPreAssessmentActive } from "./pre-assessment-active.svg";
import { ReactComponent as MenuFeed } from "./feed.svg";
import { ReactComponent as MenuFeedActive } from "./feed-active.svg";
import { ReactComponent as MenuRota } from "./rota.svg";
import { ReactComponent as MenuRotaActive } from "./rota-active.svg";
import { ReactComponent as MenuLeave } from "./leave.svg";
import { ReactComponent as MenuLeaveActive } from "./leave-active.svg";
import { ReactComponent as MenuTimesheet } from "./timesheet.svg";
import { ReactComponent as MenuTimesheetActive } from "./timesheet-active.svg";
import { ReactComponent as MenuHome } from "./home.svg";
import { ReactComponent as MenuHomeActive } from "./home-active.svg";
import { ReactComponent as MenuFolder } from "./folder.svg";
import { ReactComponent as MenuFolderActive } from "./folder-active.svg";
import { ReactComponent as MenuVisitors } from "./visitors.svg";
import { ReactComponent as MenuVisitorsActive } from "./visitors-active.svg";
import { ReactComponent as MenuResidents } from "./resident.svg";
import { ReactComponent as MenuResidentsActive } from "./resident-active.svg";
import { ReactComponent as MenuResidentSettings } from "./resident-settings.svg";
import { ReactComponent as MenuResidentSettingsActive } from "./resident-settings-active.svg";
import { ReactComponent as MenuResidentRounds } from "./resident-rounds.svg";
import { ReactComponent as MenuResidentRoundsActive } from "./resident-rounds-active.svg";
import { ReactComponent as MenuMaintenance } from "./maintenance.svg";
import { ReactComponent as MenuMaintenanceActive } from "./maintenance-active.svg";
import { ReactComponent as MenuKitchen } from "./kitchen.svg";
import { ReactComponent as MenuKitchenActive } from "./kitchen-active.svg";
import { ReactComponent as MenuFeedback } from "./feedback.svg";
import { ReactComponent as MenuFeedbackActive } from "./feedback-active.svg";

const MenuIcons = {
  MenuCompany,
  MenuCompanyActive,
  MenuEmployee,
  MenuEmployeeActive,
  MenuEngagement,
  MenuEngagementActive,
  MenuLeads,
  MenuLeadsActive,
  MenuLocation,
  MenuLocationActive,
  MenuProfileReview,
  MenuProfileReviewActive,
  MenuPreAssessment,
  MenuPreAssessmentActive,
  MenuFeed,
  MenuFeedActive,
  MenuRota,
  MenuRotaActive,
  MenuLeave,
  MenuLeaveActive,
  MenuTimesheet,
  MenuTimesheetActive,
  MenuHome,
  MenuHomeActive,
  MenuFolder,
  MenuFolderActive,
  MenuVisitors,
  MenuVisitorsActive,
  MenuResidents,
  MenuResidentsActive,
  MenuResidentSettings,
  MenuResidentSettingsActive,
  MenuResidentRounds,
  MenuResidentRoundsActive,
  MenuMaintenance,
  MenuMaintenanceActive,
  MenuKitchen,
  MenuKitchenActive,
  MenuFeedback,
  MenuFeedbackActive,
};

export default MenuIcons;
